import { render, staticRenderFns } from "./score.vue?vue&type=template&id=98e9e714&scoped=true"
import script from "./score.vue?vue&type=script&lang=js"
export * from "./score.vue?vue&type=script&lang=js"
import style0 from "./score.vue?vue&type=style&index=0&id=98e9e714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e9e714",
  null
  
)

export default component.exports